module.exports = __webpack_public_path__ + "img/help_delivery_key_en.5b88b83d.png";